// eslint-disable-next-line no-restricted-imports
import { ConsentResource, useConsentsCommon } from '@eih-netbroker/common';
import { useMemo } from 'react';
import { useResource, useResourceHeaders } from './useResource';

export const useConsents = () => {
  const { getResourceHeaderWithToken } = useResourceHeaders();
  const consentResource = useResource(ConsentResource);

  const p = useMemo(
    () => ({
      consentResource,
      getResourceHeaderWithToken,
    }),
    [consentResource, getResourceHeaderWithToken],
  );

  return useConsentsCommon(p);
};
